import { type FullPageEditorPresetAPI } from '@confluence/full-page-editor-store';
import { LoadableAfterPaint } from '@confluence/loadable';

type SendContentFeaturesProps = {
	contentId: string;
	editorApi?: FullPageEditorPresetAPI | null;
	isInEditor?: boolean;
	isAbbreviatedReadTime?: boolean;
	isDetailsPanel?: boolean;
	showWordCount?: boolean;
};

export const ReadTime = LoadableAfterPaint<SendContentFeaturesProps>({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ReadTime" */ '../src/ReadTime')).ReadTimeLoader,
});
